import { Box, Stack } from '@mui/material';
import Text from '../text';
import BaseSwitch from '../form/base-switch';
import { FC } from 'react';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { createUseStyles } from 'react-jss';

interface Props {
  label: string;
  checked: boolean;
  tooltip?: string;
  inline?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = createUseStyles({
  preferenceTooltip: {
    height: 16,
    overflow: 'hidden',
  },
});

const PreferenceControl: FC<Props> = ({
  label,
  checked,
  onChange,
  tooltip = '',
  inline = false,
}) => {
  const styles = useStyles();
  const hasTooltip = !!tooltip && !inline;
  const hasDescription = !!tooltip && inline;

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Text size="small">{label}</Text>

        <Stack direction="row" gap={0.5} alignItems="center">
          {hasTooltip && (
            <Tooltip title={tooltip} className={styles.preferenceTooltip}>
              <Icon name="info-circle" size="small" color="grey" />
            </Tooltip>
          )}
          <BaseSwitch checked={checked} onChange={onChange} size="small" />
        </Stack>
      </Stack>
      {hasDescription && (
        <Box mt={0.5}>
          <Text size="small" color="grey">
            {tooltip}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default PreferenceControl;
